interface PaymentCancelledData {
  totalCancelled: number;
  monthlyCancelled: number;
  weeklyCancelled: number;
  dailyCancelled: number;
}

interface PaymentCancelledCardProps {
  cancelledData: PaymentCancelledData;
}

const PaymentCancelledCard: React.FC<PaymentCancelledCardProps> = ({ cancelledData }) => {
  return (
    <div className="rounded-sm border border-stroke bg-white py-6 px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark hover:shadow-lg transition-shadow duration-200 cursor-pointer">
      <div className="mx-2">
        <div>
          <span className="text-sm font-medium">Payment Cancelled</span>
        </div>
        
        <div className="mt-3 grid grid-cols-2 gap-2">
          <div className="text-left">
            <h5 className="text-sm font-semibold text-red-600 dark:text-red-400">
              {cancelledData.monthlyCancelled}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Monthly
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
              {cancelledData.weeklyCancelled}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Weekly
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-yellow-600 dark:text-yellow-400">
              {cancelledData.dailyCancelled}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Daily
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-gray-600 dark:text-gray-400">
              {cancelledData.totalCancelled}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              All Time
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledCard;